'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('gallery-edit', {
      url: '/gallery/edit/:type/:id',
      template: '<gallery-edit></gallery-edit>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/gallery/edit/gallery-edit.routes.js